<ng-template #loaderBlock>
  <app-loader></app-loader>
</ng-template>
<div class="training-wrapper">
  <app-grouped-bar-chart
    *ngIf="trainingCertification"
    [name]="'trainingCertification'"
    [data]="trainingCertification"
    [columns]="columns"
    [colors]="colors"
    [legends]="legends"
  ></app-grouped-bar-chart>
  <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
</div>
